

export default class {
    constructor($el, windowPal) {
        this.$ul = $el;
        this.windowPal = windowPal;
        // console.log($el[0]);
        this.MAX_WIDTH = 750;
        this.isMobile = null;
        this.$outer = $('<div class="mobile-carousel-outer">');
        this.$window = $('<div class="-window">');
        this.$left = $('<div class="-left">');
        this.$right = $('<div class="-right">');
        this.cols = 3;
        this.$cells = this.$ul.find('li');
        this.$firstCell = $(this.$cells[0]);
        windowPal.resize(()=>{
            this.resize();
        });
        this.resize();
        this.setup();
        this.$left.click(()=>{
            this.click(0 - this.cols);
        });
        this.$right.click(()=>{
            this.click(this.cols);
        });
    }
    click(inc) {
        let currentPosPx = this.$window.scrollLeft(),
            cellWidth = this.$firstCell.outerWidth(true),
            currentPos = Math.round(currentPosPx / cellWidth);
        // console.log(currentPosPx, cellWidth, currentPos);
        this.moveTo((currentPos + inc) * cellWidth);
    }
    moveTo(px) {
        // console.log(px);
        this.$window.animate({scrollLeft:px}, 200, 'swing', function() {
            // console.log('done');
        });
    }
    resize() {
        let windowWidth = this.windowPal.$.width();
        // console.log('resize mobile-carousel', windowWidth);
        if (windowWidth > this.MAX_WIDTH) {
            if (this.isMobile !== false) {
                this.isMobile = false;
                this.$outer.removeClass('-is-mobile');
            }
        } else {
            if (this.isMobile !== true) {
                this.isMobile = true;
                this.$outer.addClass('-is-mobile');
            }
        }
    }
    setup() {
        this.$ul.after(this.$outer);
        this.$outer.append(this.$left.append($('<div class="-triangle">')));
        this.$outer.append(this.$window.append(this.$ul));
        this.$outer.append(this.$right.append($('<div class="-triangle">')));
        this.$cells.each((i, el)=>{
            let $li = $(el),
                $fig = $li.find('figure'),
                $img = $fig.find('img'),
                src = $img.attr('src');
            $fig.css('background-image', 'url("'+src+'")');
        });
    }
}















// WEBPACK FOOTER //
// ./scripts/lib/MobileCarousel.js